<template>
    <div class="search-results-header">
        <button @click="handleFilters" class="search-results-header__filter">
            <i class="icon-filter"/> Filter
        </button>
        <div class="search-results-header__inner">
            <div class="search-results-header__total" v-if="resultsLabel" v-html="resultsLabel"></div>
            <div class="material material-select search-results-header__select-wrapper">
                <label for="sort-select" class="search-results-header__label"
                       v-if="sortByLabel">{{ sortByLabel }}: </label>
                <select id="sort-select" class="form-control material-input search-results-header__select"
                        @change="changeHandler" ref="sort">
                    <template v-for="(option, index) in options">
                        <option v-if="option.label && option.value"
                            :key="index"
                            :value="option.value"
                            :selected="$store.getters['order'] === option.value">
                            {{ option.label }}
                        </option>
                    </template>
                </select>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    methods: {
        changeHandler (e) {
            this.$store.dispatch('setOrder', e.target.value);
        },
        handleFilters () {
            if (this.$store.getters['filtersActive']) {
                this.$store.dispatch('deactivateFilters');
            } else {
                this.$store.dispatch('activateFilters');
            }
        }
    },
    computed: {
        sortByLabel () {
            return wp_variables.search.sort_by_label;
        },
        resultsLabel () {
            return wp_variables.search.results_label.replace('%s', this.$store.getters['total']);
        },
        options () {
            return [
                {
                    label: wp_variables.search.relevance_sort_label,
                    value: 'relevance:desc',
                },
                {
                    label: wp_variables.search.date_ascending_sort_label,
                    value: 'date:asc',
                },
                {
                    label: wp_variables.search.date_descending_sort_label,
                    value: 'date:desc',
                }
            ];
        }
    }
};
</script>
